var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dashboard',{staticClass:"jagfx wrapper",scopedSlots:_vm._u([{key:"default",fn:function(dashProps){return [_c('div',{staticClass:"dashboard",style:({
        transform:
          'scale(' + dashProps.currentScale + ') translate(-50%, -50%)',
        width: dashProps.skinData.size.width + 'px',
        height: dashProps.skinData.size.height + 'px'
      })},[_c('div',{staticClass:"zone-wrapper w-100"},[_c('div',{staticClass:"left"},[_c('JagfxTrailer',{attrs:{"id":"trailers"}}),_c('JagfxJob',{attrs:{"id":"job"}})],1)]),_c('JagfxNavigation',{staticClass:"w-100",attrs:{"id":"navigation"}}),_c('div',{staticClass:"zone-wrapper w-100 h-100"},[_c('JagfxTruck',{attrs:{"id":"truck"}})],1)],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }